<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Invoices',
  data () {
    return {
    }
  },
  mounted () {
    this.$store.dispatch('invoice/reset')
    this.$store.dispatch('systemSetting/loadSystemSettings')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invoices/index.vue